import React, { useMemo } from "react";
import { FaCheck } from "react-icons/fa";
import { CMS_PRIMARY } from "../TaskManagement/workspaceConstants";
import CommissionsSingleSelect from "../reports/commissions/CommissionsMultiSelect";
import CommissionsActiveChips from "../reports/commissions/CommissionsActiveChips";
import AccountsNameMultiSelect from "./AccountsNameMultiSelect";
import {
  FILTER_CARD_CLASS,
  FILTER_FIELD_CLASS,
  FILTER_PANEL_INNER_CLASS,
  FILTER_ROW_CLASS,
} from "../reports/commissions/commissionsConstants";
import {
  buildAccountsActiveChips,
} from "./useAccountsFilters";
import { sortedCountries } from "../../utilis/countryCurrency";

const FILTER_BTN_RESET = {
  border: "none",
  outline: "none",
  WebkitAppearance: "none",
  appearance: "none",
};

function FilterFooter({ chips, onRemoveChip, onReset, onApply }) {
  return (
    <div className="mt-3 flex w-full items-start justify-between gap-4 border-t border-[#E2E8F0] pt-3">
      <div className="flex min-w-0 flex-1 flex-wrap items-center justify-start gap-x-2 gap-y-1.5 text-left">
        {chips.length > 0 && (
          <>
            <span className="shrink-0 text-xs font-medium text-gray-500">
              Active Filters:
            </span>
            <CommissionsActiveChips chips={chips} onRemove={onRemoveChip} />
          </>
        )}
      </div>
      <div className="ml-auto flex shrink-0 items-center gap-2">
        <button
          type="button"
          onClick={onReset}
          className="inline-flex h-9 items-center rounded-lg border border-[#E5E7EB] bg-white px-4 text-xs font-medium text-gray-600 shadow-sm transition hover:border-gray-300 hover:bg-gray-50"
          style={FILTER_BTN_RESET}
        >
          Reset
        </button>
        <button
          type="button"
          onClick={onApply}
          className="inline-flex h-9 items-center gap-1.5 rounded-lg px-4 text-xs font-semibold text-white transition hover:brightness-95"
          style={{
            ...FILTER_BTN_RESET,
            backgroundColor: CMS_PRIMARY,
            boxShadow: "0 1px 2px rgba(0, 123, 255, 0.25)",
          }}
        >
          <FaCheck size={10} />
          Apply Filters
        </button>
      </div>
    </div>
  );
}

function AccountsSearchFilters({
  draft,
  onDraftChange,
  participants,
  roleOptions,
  branchOptions,
  statusOptions,
  onApply,
  onReset,
  onRemoveChip,
}) {
  const chips = useMemo(
    () => buildAccountsActiveChips(draft, roleOptions, branchOptions),
    [draft, roleOptions, branchOptions],
  );

  const countryOptions = useMemo(
    () =>
      sortedCountries.map((c) => ({
        id: c.value,
        name: c.value,
      })),
    [],
  );

  return (
    <div className={`mt-3 ${FILTER_CARD_CLASS}`}>
      <div className={FILTER_PANEL_INNER_CLASS}>
        <div className={FILTER_ROW_CLASS}>
          <div className={`${FILTER_FIELD_CLASS} min-w-[180px]`}>
            <AccountsNameMultiSelect
              value={draft.names}
              onChange={(names) => onDraftChange({ ...draft, names })}
              options={participants}
              placeholder="All names"
              searchPlaceholder="Search users..."
            />
          </div>

          <div className={FILTER_FIELD_CLASS}>
            <CommissionsSingleSelect
              label="Country"
              value={draft.country}
              onChange={(country) => onDraftChange({ ...draft, country })}
              options={countryOptions}
              placeholder="All countries"
              searchPlaceholder="Search countries..."
            />
          </div>

          <div className={FILTER_FIELD_CLASS}>
            <CommissionsSingleSelect
              label="Role"
              value={draft.roleId}
              onChange={(roleId) => onDraftChange({ ...draft, roleId })}
              options={roleOptions}
              placeholder="All roles"
              searchPlaceholder="Search roles..."
            />
          </div>

          <div className={FILTER_FIELD_CLASS}>
            <CommissionsSingleSelect
              label="Branch"
              value={draft.branchName}
              onChange={(branchName) => onDraftChange({ ...draft, branchName })}
              options={branchOptions}
              placeholder="All branches"
              searchPlaceholder="Search branches..."
            />
          </div>

          <div className={FILTER_FIELD_CLASS}>
            <CommissionsSingleSelect
              label="Status"
              value={draft.status}
              onChange={(status) => onDraftChange({ ...draft, status })}
              options={statusOptions}
              placeholder="All statuses"
              searchPlaceholder="Search status..."
            />
          </div>
        </div>

        <FilterFooter
          chips={chips}
          onRemoveChip={onRemoveChip}
          onReset={onReset}
          onApply={onApply}
        />
      </div>
    </div>
  );
}

export default AccountsSearchFilters;
